import { createV3Queries } from "@query/utils/createV3Queries";
import { apiKeysApi } from "@api";

export const queriesApiKeys = createV3Queries("apiKeysApi", apiKeysApi);
